import { string, node, oneOf } from 'prop-types';
import React from 'react';
import Icon from '../Icon/index.jsx';
import Tooltip from '../Tooltip/index';
import { Box } from '../Layout/index';
import { useTheme } from 'emotion-theming';
import { get } from '@styled-system/css';
import styled from '@emotion/styled';

const StyledSection = styled('section')(
  {
    borderRadius: '6px',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  ({ colors }) => ({
    border: `1px solid ${colors.border}`,
    backgroundColor: colors.backgroundColor,
  }),
);

const StyledHeader = styled('header')(
  {
    padding: '16px 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: '6px 6px 0 0',
  },
  ({ theme, colors }) => ({
    backgroundColor: colors.headerBackgroundColor || colors.backgroundColor,
    borderBottom: `1px solid ${theme.colors.borderAccent}`,
  }),
);

const StyledIcon = styled('div')({
  position: 'absolute',
  right: '10px',
  top: '4px',
});

const Panel = ({ header, children, info, intent = 'neutral', className, ...boxProps }) => {
  const theme = useTheme();
  const config = get(theme, 'components.Panel', {});
  const colors = get(config, `intents.${intent}`, {});

  return (
    <StyledSection colors={colors} className={className}>
      {header && <StyledHeader colors={colors}>{header}</StyledHeader>}
      <Box position="relative" height="100%" {...boxProps}>
        {children}
      </Box>
      {info && (
        <StyledIcon>
          <Tooltip content={info} position="left">
            <Icon name="warning-circle" size={14} color="Mid Neutral 2" />
          </Tooltip>
        </StyledIcon>
      )}
    </StyledSection>
  );
};

Panel.propTypes = {
  intent: oneOf(['neutral', 'warning']),
  info: string,
  className: string,
  header: node,
  children: node.isRequired,
};

export default Panel;
